import React from 'react';

// A selectable card that shows a teal border + light teal bg when selected.
export function OptionCard({ selected, onChange, children, disabled = false }) {
    return (
        <div
            className={`option-card ${selected ? 'option-card--selected' : ''} ${disabled ? 'option-card--disabled' : ''}`}
            onClick={disabled ? undefined : onChange}
            role="checkbox"
            aria-checked={selected}
            tabIndex={disabled ? -1 : 0}
            onKeyDown={(e) => {
                if (!disabled && (e.key === ' ' || e.key === 'Enter')) {
                    e.preventDefault();
                    onChange();
                }
            }}
        >
            <div className="option-card__check">
                <div className={`option-card__box ${selected ? 'option-card__box--checked' : ''}`}>
                    {selected && (
                        <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
                            <path d="M1 5L4.5 8.5L11 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    )}
                </div>
            </div>
            <div className="option-card__body">
                {children}
            </div>
        </div>
    );
}